import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Stack, Typography } from "@mui/material";

import { Header, MainColorButton } from "../../components";
import { rowRightBottomButton, rowLeftBottomButton } from "../../common/styles";
import { MEDICAL_QUESTIONNAIRES, PHARMACY_SELECTOR } from "../../routes/path";
import store from "../../store";
import { closeWindow } from "../../utils/getLineProfile";

/**
 * 処方箋申込　[問診未登録]
 * @returns
 */
const InterviewNotRegistered = () => {
  const [endY, setEndY] = useState(0);
  const navigate = useNavigate();
  let location = useLocation();
  const { siteId, customerId } = location.state;
  const setCustomerSelected = (state) => state.prescription.customerSelected;
  let customerSelected = setCustomerSelected(store.getState());
  const data = {
    siteId: location.state?.siteId,
    customerId: location.state?.customerId || "",
    gender: location.state.gender,
    familyId: location.state.familyId,
    birthday: location.state.birthday || "",
    name: location.state.name || "",
  };

  return (
    <div
      onTouchStartCapture={(e) => {
        setEndY(0);
      }}
      onTouchMoveCapture={(e) => {
        setEndY(e.touches[0].clientY);
      }}
      onTouchEndCapture={(e) => {
        if (endY !== 0) {
          e.stopPropagation();
        }
      }}
    >
      <Header title="処方箋申込　[問診未登録]" />
      <Box
        height="81vh"
        marginTop="9vh"
        width="95%"
        marginLeft="auto"
        marginRight="auto"
      >
        <Stack>
          <Typography variant="subtitle1" align="left">
            「{customerSelected.selectedRows.name}
            」様は問診が完了しておりません。<br></br>
            　問診を登録の上、処方箋の申込をお願いします。
          </Typography>
        </Stack>
      </Box>
      <Stack direction="row">
        <MainColorButton
          label="閉じる"
          onClick={() => closeWindow()}
          style={rowLeftBottomButton}
        />

        <MainColorButton
          label="問診登録"
          onClick={() => {
            navigate(MEDICAL_QUESTIONNAIRES, {
              state: {
                customerId: customerId || data.customerId,
                siteId: siteId || data.siteId,
                gender: data.gender,
                familyId: data.familyId,
                birthday: data.birthday,
                name: data.name,
                destination: PHARMACY_SELECTOR,
              },
            });
          }}
          style={rowRightBottomButton}
        />
      </Stack>
    </div>
  );
};

export default InterviewNotRegistered;
